import React, {useMemo} from 'react';
import {Grid, GridCol} from '@flixbus/honeycomb-react';
import {useReadOnlyKpiInputConfigBuilder} from '@/Pages/ProductionCost/components/DataImportStepTwo/hooks/useReadOnlyKpiInputConfigBuilder';
import ReadOnlyInput from '@/components/ReadOnlyInput/ReadOnlyInput';
import {LineScheduleVehicleDriverShiftsKpisListProps} from './LineScheduleVehicleDriverShiftsKpisList.types';
import {getLineScheduleVehicleDriverShiftsKpisConfig} from './LineScheduleVehicleDriverShiftsKpisList.data';

const LineScheduleVehicleDriverShiftsKpisList: React.FC<
  LineScheduleVehicleDriverShiftsKpisListProps
> = ({vehicleEntryId, kpis}) => {
  const kpisConfig = useMemo(
    () => getLineScheduleVehicleDriverShiftsKpisConfig(vehicleEntryId),
    [vehicleEntryId]
  );

  const inputs = useReadOnlyKpiInputConfigBuilder(kpis ?? null, kpisConfig);

  if (!inputs.length) return null;

  return (
    <Grid gutterSize="4">
      {inputs.map(input => (
        <GridCol key={input.id} inline>
          <ReadOnlyInput
            extraClasses="content-secondary-color"
            horizontal
            {...input}
          />
        </GridCol>
      ))}
    </Grid>
  );
};

export default React.memo(LineScheduleVehicleDriverShiftsKpisList);
